<template>
    <div id="communities">
        <div class="communities-header">
            <img src="https://elitecrafthomes.com/static_files/images/community_page/communities_header.jpg" alt="">
        </div>

        <div class="list-communities">
            <p class="list-title">Communities</p>
            <div class="search-communities-select">
                <v-select :items="communities.locationSet" v-model="communities.selectedCommunities" chips deletable-chips
                          label="All Locations" max-height="400" persistent-hint auto
                          @input="mapSmallFilter()"></v-select>
            </div>

            <div class="search-communities">
                <p @click="communities.city = 'all'; communities.showMore = false"
                   :class="communities.city === 'all' ? 'active' : ''">All Locations</p>
                <!-- TODO - how to make a dynamic link based off the path from the list-->
                <p @click="communities.city = communities.locationSet[communities.communityIndexOne]; communities.showMore = false"
                   :class="activeCommunityOne">
                    {{ communityOne }}</p>
                <p @click="communities.city = communities.locationSet[communities.communityIndexTwo]; communities.showMore = false"
                   :class="activeCommunityTwo">
                    {{ communityTwo }}</p>
                <p class="city" @click="communities.showMore = !communities.showMore">More
                    <v-icon v-if="communities.showMore === false" large>expand_more</v-icon>
                    <v-icon v-else large>expand_less</v-icon>
                </p><br/>
                <div v-show="communities.showMore" id="showMore">
                    <p @click="communities.city = community"
                       v-for="(community, i) in communities.locationSet"
                       :class="communities.city === community ? 'active city' : 'city'"
                       v-if="i > communities.communityIndexTwo && community !== null && community !== 'null'">{{ community }}</p>
                </div>
            </div>
            <br>
            <!-- Display all communities -->
            <div class="community" v-for="(community, i) in showCommunities(communities.city)" :key="i"
                 v-if="community.disabled === false && communities.communities.length > 1">
                <router-link tag="img" :to="{ path: '/communities/' + community.community_name }"
                             :src="community.thumbnail_src"></router-link>
                <!-- TODO - perhaps do a v-show to show elements based on if the community is in the selected communities-->
                <div>
                    <router-link :to="{ path: '/communities/' + community.community_name }">{{ community.title }}</router-link>
                    <p>City: {{ community.location.city }}</p>
                    <p>Acres: {{ community.acres }}</p>
                    <p>Available Lots: {{ community.available_lots }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const data = {
        communities: {
            locations: [],
            cities: [],
            communities: [],
            selectedCommunities: [],
            shownCommunities: [],
            active: false,
            city: 'all',
            counter: 0,
            showMore: false,
            imagePath: 'https://elitecrafthomes.com/static_files/images/communities',
            communityIndexOne: 0,
            communityIndexTwo: 0,
            locationSet: []
        }
    };

    import axios from 'axios';

    const apiToken = require('../../../credentials').API_TOKEN;
    const urlPath = require('../../../credentials').URL_PATH;

    export default {
        name: 'Communities',
        data() {
            return data;
        },
        computed: {
            communitiesList() {
                // TODO - make a set of all commmunities from 2 to end in the array. Display the first 2 cities in the list along with all locations

            },
            communityOne() {
                if (this.communities.communities[0] !== undefined && this.communities.communities[0] !== 'undefined') {
                    for (let i = 0; i < this.communities.locationSet.length; i++) {
                        if (this.communities.locationSet[i] !== null) {
                            this.communities.communityIndexOne = i;
                            // console.log(this.communities.communityIndexOne, this.communities.locationSet[i]);
                            return this.communities.locationSet[i]
                        }
                    }
                }
            },
            communityTwo() {
                if (this.communities.communities[0] !== undefined && this.communities.communities[0] !== 'undefined') {
                    for (let i = this.communities.communityIndexOne + 1; i < this.communities.locationSet.length; i++) {
                        if (this.communities.locationSet[i] !== null) {
                            this.communities.communityIndexTwo = i;
                            // console.log(this.communities.communityIndexTwo, this.communities.locationSet[i]);
                            return this.communities.locationSet[i]
                        }
                    }
                }
            },
            activeCommunityOne() {
                if (this.communities.communities[0] !== undefined && this.communities.communities[0] !== 'undefined') {
                    if (this.communities.city === this.communities.locationSet[this.communities.communityIndexOne]) {
                        return 'active city';
                    } else {
                        return 'city'
                    }
                }
            },
            activeCommunityTwo() {
                if (this.communities.communities[0] !== undefined && this.communities.communities[0] !== 'undefined') {
                    if (this.communities.city === this.communities.locationSet[this.communities.communityIndexTwo]) {
                        return 'active city';
                    } else {
                        return 'city'
                    }
                }
            }
        },
        methods: {
            mapSmallFilter() {
                this.communities.city = this.communities.selectedCommunities;
            },
            parseLocationSet() {
                let temp = new Set();
                for (let i = 0; i < this.communities.communities.length; i++) {
                    if (this.communities.communities[i].disabled === false) {
                        temp.add(this.communities.communities[i].location.city);
                    }
                }
                this.communities.locationSet = [...temp];
            },
            loadLocations() {
                axios.get(urlPath + 'locations/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Headers': 'true',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Token ${apiToken}`
                    }
                })
                    .then((res) => {
                        this.communities.locations = res.data;
                        this.communities.cities = [...new Set(res.data.map(location => location.city))];
                    })
            },

            loadCommunities() {
                axios.get(urlPath + 'communities/communities/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Headers': 'true',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Token ${apiToken}`
                    }
                })
                    .then((res) => {
                        this.communities.communities = res.data;
                        this.communities.shownCommunities = res.data;
                        this.parseLocationSet();
                    })
            },
            showCommunities(city) {
                let comList = [];
                let tempCom = this.communities.communities;
                if (city === 'all' || city === null) {
                    return this.communities.communities;
                }
                for (let i = 0; i < tempCom.length; i++) {
                    if (tempCom[i].location.city.toLowerCase().includes(city.toLowerCase())) {
                        comList.push(tempCom[i])
                    }
                }
                return comList;
            }
        },
        created() {
            this.loadLocations();
            this.loadCommunities();
        },
        beforeMount() {
            this.communities.city = 'all';
            this.communities.active = false;
        }
    }
</script>

<style lang="scss" scoped>
    @font-face {
        font-family: "Tahu";
        src: url("https://elitecrafthomes.com/static_files/fonts/Tahu.ttf"),
        url("https://elitecrafthomes.com/static_files/fonts/Tahu.otf") format('opentype');
    }

    @font-face {
        font-family: "LibreBaskerville Bold";
        src: url("https://elitecrafthomes.com/static_files/fonts/LibreBaskerville-Bold.ttf")
    }

    @media screen and (max-width: 450px) {
        #communities {
            background-color: white;
            text-align: center;
            div.communities-header {
                max-width: 100%;
                width: 100%;
                max-height: 430px;
                height: 430px;
                position: relative;
                img {
                    max-width: 100%;
                    width: 100%;
                    max-height: 430px;
                    height: 430px;
                    object-fit: fill;
                }
            }

            div.list-communities {
                margin: 50px auto 75px auto;
                text-align: center;
                padding: 0 10px;
                p.list-title {
                    font-size: 24px;
                    font-weight: bold;
                    font-family: "LibreBaskerville Bold", "Muli", "Avenir", "Helvetica Neue", serif;
                }
                div.search-communities {
                    display: none;
                }
                div.search-communities-select {
                    max-width: 75vw;
                    margin: 0 auto 50px auto;
                }

                .community {
                    position: relative;
                    height: 150px;
                    img {
                        max-width: 167px;
                        width: 167px;
                        max-height: 152px;
                        height: 152px;
                        object-fit: fill;
                    }
                    div {
                        position: absolute;
                        width: 50vw;
                        top: 50%;
                        -webkit-transform: translateY(-50%);
                        -moz-transform: translateY(-50%);
                        -ms-transform: translateY(-50%);
                        -o-transform: translateY(-50%);
                        transform: translateY(-50%);

                        a:nth-of-type(1) {
                            font-weight: 600;
                            font-size: 20px;
                            text-decoration: none;
                            color: black;
                            line-height: 1;
                        }
                        p {
                            font-weight: 400;
                            padding: 0;
                            margin: 0;
                        }
                    }
                }
                .community:nth-child(odd) {
                    img {

                        float: left;
                    }

                    div {
                        padding-left: 20px;
                        right: 0;
                        text-align: left;
                    }
                }

                div.community:nth-child(even) {
                    img {
                        position: absolute;
                        right: 0;
                    }
                    div {
                        text-align: right;
                        padding-right: 20px;
                        left: 0;
                    }
                }
            }
        }
    }

    @media screen and (min-width: 451px) and (max-width: 768px) {
        #communities {
            background-color: white;
            text-align: center;
            div.communities-header {
                max-width: 100%;
                width: 100%;
                max-height: 600px;
                height: 600px;
                position: relative;
                img {
                    max-width: 100%;
                    width: 100%;
                    max-height: 600px;
                    height: 600px;
                    object-fit: fill;
                }
            }

            div.list-communities {
                margin: 50px auto 75px auto;
                text-align: center;
                padding: 0 10px;
                max-width: 600px;
                width: 100%;
                p.list-title {
                    font-size: 32px;
                    font-weight: bold;
                    font-family: "LibreBaskerville Bold", "Muli", "Avenir", "Helvetica Neue", serif;
                }
                div.search-communities {
                    margin: 20px auto 50px auto;
                    display: inline-block;
                    p {
                        cursor: pointer;
                    }
                    p:first-child {
                        font-size: 20px;
                        font-weight: 400;
                        display: inline-block;
                        margin-right: 10px;
                    }
                    .city {
                        margin: 0 10px;
                        font-size: 20px;
                        font-weight: 400;
                        display: inline-block;
                        border: none;
                    }
                    .city.active, .active, p:first-child.active {
                        font-weight: bold;
                        border-top: 2px solid black;
                        border-bottom: 2px solid black;
                    }
                    #showMore {
                        border-top: 2px solid black;
                        border-bottom: 2px solid black;
                        p.city.active {
                            font-weight: bold;
                            padding: 20px auto;
                            border: none;
                        }
                    }
                }
                div.search-communities-select {
                    display: none;
                }

                .community {
                    position: relative;
                    max-width: 255px;
                    width: 255px;
                    height: 300px;
                    display: inline-block;
                    text-align: center;
                    img {
                        max-width: 255px;
                        width: 255px;
                        max-height: 167px;
                        height: 167px;
                        object-fit: fill;
                    }
                    div {
                        position: absolute;
                        width: 100%;
                        bottom: 0;
                        text-align: center;
                        margin: 0 auto;
                        a:nth-of-type(1) {
                            font-weight: 600;
                            font-size: 20px;
                            padding-bottom: 10px;
                            text-align: center;
                            text-decoration: none;
                            color: black;
                            line-height: 1;
                        }
                        p {
                            font-weight: 400;
                            padding: 0;
                            margin: 0;
                            text-align: center;
                        }
                    }
                }
                .community:nth-child(odd) {
                    margin: 0 35px 25px 0;

                }

                div.community:nth-child(even) {
                    margin: 0 0 25px 35px;
                }
            }
        }
    }

    @media screen and (min-width: 769px) and (max-width: 1024px) {
        #communities {
            background-color: white;
            text-align: center;
            div.communities-header {
                max-width: 100%;
                width: 100%;
                max-height: 600px;
                height: 600px;
                position: relative;
                img {
                    max-width: 100%;
                    width: 100%;
                    max-height: 600px;
                    height: 600px;
                    object-fit: fill;
                }
            }

            div.list-communities {
                margin: 50px auto 75px auto;
                text-align: center;
                padding: 0 10px;
                max-width: 600px;
                width: 100%;
                p.list-title {
                    font-size: 32px;
                    font-weight: bold;
                    font-family: "LibreBaskerville Bold", "Muli", "Avenir", "Helvetica Neue", serif;
                }
                div.search-communities {
                    margin: 20px auto 50px auto;
                    display: inline-block;
                    p {
                        cursor: pointer;
                    }
                    p:first-child {
                        font-size: 20px;
                        font-weight: 400;
                        display: inline-block;
                        margin-right: 10px
                    }
                    .city {
                        margin: 0 10px;
                        font-size: 20px;
                        font-weight: 400;
                        display: inline-block;
                        border: none;
                    }
                    .city.active, .active, p:first-child.active {
                        font-weight: bold;
                        border-top: 2px solid black;
                        border-bottom: 2px solid black;
                    }
                    #showMore {
                        border-top: 2px solid black;
                        border-bottom: 2px solid black;
                        p.city.active {
                            font-weight: bold;
                            padding: 20px auto;
                            border: none;
                        }
                    }
                }
                div.search-communities-select {
                    display: none;
                }

                .community {
                    position: relative;
                    max-width: 255px;
                    width: 255px;
                    height: 300px;
                    display: inline-block;
                    text-align: center;
                    img {
                        max-width: 255px;
                        width: 255px;
                        max-height: 167px;
                        height: 167px;
                        object-fit: fill;
                    }
                    div {
                        position: absolute;
                        width: 100%;
                        bottom: 0;
                        text-align: center;
                        margin: 0 auto;
                        a:nth-of-type(1) {
                            font-weight: 600;
                            font-size: 20px;
                            padding-bottom: 10px;
                            text-align: center;
                            text-decoration: none;
                            color: black;
                        }
                        p {
                            font-weight: 400;
                            padding: 0;
                            margin: 0;
                            text-align: center;
                        }
                    }
                }
                .community:nth-child(odd) {
                    margin: 0 35px 25px 0;

                }

                .community:nth-child(even) {
                    margin: 0 0 25px 35px;
                }
            }
        }
    }

    @media screen and (min-width: 1025px) {
        #communities {
            background-color: white;
            text-align: center;
            div.communities-header {
                max-width: 100%;
                width: 100%;
                max-height: 530px;
                height: 530px;
                position: relative;
                img {
                    max-width: 100%;
                    width: 100%;
                    max-height: 530px;
                    height: 530px;
                    object-fit: fill;
                }
            }

            div.list-communities {
                margin: 50px auto 75px auto;
                text-align: center;
                padding: 0 10px;
                max-width: 1200px;
                width: 100%;
                p.list-title {
                    font-size: 32px;
                    font-weight: bold;
                    font-family: "LibreBaskerville Bold", "Muli", "Avenir", "Helvetica Neue", serif;
                }
                div.search-communities {
                    margin: 20px auto 50px auto;
                    display: inline-block;
                    p {
                        cursor: pointer;
                    }
                    p:first-child {
                        font-size: 1.5em;
                        font-weight: 400;
                        display: inline-block;
                        margin-right: 10px
                    }
                    .city {
                        padding: 7px;
                        margin: 0 10px;
                        font-size: 1.5em;
                        font-weight: 400;
                        display: inline-block;
                        border: none;
                    }
                    .city.active, .active, p:first-child.active {
                        padding: 7px;
                        font-weight: bold;
                        border-top: 2px solid black;
                        border-bottom: 2px solid black;
                    }
                    #showMore {
                        border-top: 2px solid black;
                        border-bottom: 2px solid black;
                        p.city.active {
                            font-weight: bold;
                            padding: 20px auto;
                            border: none;
                        }
                    }
                }
                div.search-communities-select {
                    display: none;
                }

                .community {
                    position: relative;
                    max-width: 255px;
                    width: 255px;
                    height: 285px;
                    display: inline-block;
                    text-align: center;
                    margin: 15px 10px 25px 10px;
                    img {
                        max-width: 255px;
                        width: 255px;
                        max-height: 167px;
                        height: 167px;
                        object-fit: fill;
                        cursor: pointer;
                        margin: 0;
                        padding: 0;
                    }
                    div {
                        position: absolute;
                        width: 100%;
                        bottom: 0;
                        text-align: center;
                        margin: 0 auto;
                        a:nth-of-type(1) {
                            font-weight: 600;
                            font-size: 20px;
                            padding-bottom: 10px;
                            text-align: center;
                            text-decoration: none;
                            color: black;
                        }
                        p {
                            font-weight: 400;
                            padding: 0;
                            margin: 0;
                            text-align: center;
                        }
                    }
                }
                /*.community:nth-child(odd) {*/
                    /*margin: 0 35px 25px 0;*/

                /*}*/

                /*div.community:nth-child(even) {*/
                    /*margin: 0 0 25px 35px;*/
                /*}*/
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/communities/Communities.vue